import {Reducer} from 'redux';
import initialState from './state';
import {IReduxAction, IReduxUserState} from '../../@interfaces';
import {
    USER_CLEAR_REQUISITES,
    USER_PREFERENCES_WAS_UPDATED,
    USER_SET_ACCESS_TOKEN,
    USER_SET_PREFERENCES,
    USER_SET_USER_MODEL,
    USER_UPDATE_PREFERENCE
} from './constants';

const reducer: Reducer = (state: IReduxUserState = initialState, action: IReduxAction): IReduxUserState => {
    switch (action.type) {
        case USER_SET_ACCESS_TOKEN:
            return {...state, accessToken: action.payload};

        case USER_SET_USER_MODEL:
            return {...state, model: action.payload};

        case USER_PREFERENCES_WAS_UPDATED:
            return {...state};

        case USER_CLEAR_REQUISITES:
            const newState = {...state, accessToken: undefined, model: undefined};
            delete newState.accessToken;
            delete newState.model;

            return newState;

        case USER_SET_PREFERENCES:
            return {...state, preferences: action.payload};

        case USER_UPDATE_PREFERENCE:
            return {...state, preferences: {...state.preferences, ...action.payload}};

        default:
            break;
    }

    return state;
};

export default reducer;
